export default "__VITE_ASSET__be7a479f__"